import { useCallback, useMemo } from 'react';

import { useGraphql } from '../graphql';

// The clinician's Reviewed mark on a submitted test, which settles once saved
// or rejects with its sentence. The notes on a review save through the note
// saves above every screen (#132).
export function useReviewChanges(attemptId) {
  const graphql = useGraphql();

  const setReviewed = useCallback(function(reviewed) {
    return graphql({
      document: 'mutation Reviewed($attemptId: ID!, $reviewed: Boolean!) { setReviewed(attemptId: $attemptId, reviewed: $reviewed) { id reviewedAt } }',
      variables: { attemptId, reviewed }
    });
  }, [ graphql, attemptId ]);

  return useMemo(function() {
    return { setReviewed };
  }, [ setReviewed ]);
}
